// extracted by mini-css-extract-plugin
export var button_wraper = "strategy-module--button_wraper--fc030";
export var cardblock = "strategy-module--cardblock--59547";
export var left = "strategy-module--left--f317e";
export var right = "strategy-module--right--e2756";
export var strategy = "strategy-module--strategy--0f4c3";